module.exports = __webpack_public_path__ + "8fd56a03108b62f4a372aa03f1973702.jpg";